import { START_NODE_ID } from './nodeFactory';

// vue-flow canvas -> engine schema (targets come exclusively from edges)
export default function vueFlowToSchema(nodes, edges, viewport) {
  const edgeTarget = (source, sourceHandle) => {
    const edge = edges.find(
      e => e.source === source && e.sourceHandle === sourceHandle
    );
    return edge ? edge.target : null;
  };

  const startNode = nodes.find(node => node.id === START_NODE_ID);
  const schemaNodes = nodes
    .filter(node => node.id !== START_NODE_ID)
    .map(node => {
      const data = node.data || {};
      const config = JSON.parse(JSON.stringify(data.config || {}));
      const out = {
        id: node.id,
        type: node.type,
        title: data.title || node.type,
        position: { x: Math.round(node.position.x), y: Math.round(node.position.y) },
        config,
      };

      if (['message', 'media'].includes(node.type)) {
        const next = edgeTarget(node.id, 'next');
        if (next) out.next_node_id = next;
      }
      if (node.type === 'media') {
        const fallback = edgeTarget(node.id, 'fallback');
        if (fallback) config.fallback_target_node_id = fallback;
      }
      if (node.type === 'whatsapp_list') {
        config.sections = (config.sections || []).map(section => ({
          ...section,
          rows: (section.rows || []).map(row => {
            const target = edgeTarget(node.id, `row-${row.id}`);
            return target ? { ...row, target_node_id: target } : { ...row };
          }),
        }));
        const fallback = edgeTarget(node.id, 'fallback');
        if (fallback) config.fallback_target_node_id = fallback;
      }
      if (node.type === 'buttons') {
        config.buttons = (config.buttons || []).map(button => {
          const target = edgeTarget(node.id, `btn-${button.id}`);
          return target ? { ...button, target_node_id: target } : { ...button };
        });
        const fallback = edgeTarget(node.id, 'fallback');
        if (fallback) config.fallback_target_node_id = fallback;
      }
      return out;
    });

  return {
    start_node_id: edgeTarget(START_NODE_ID, 'next') || null,
    nodes: schemaNodes,
    ui: {
      start_position: startNode
        ? { x: Math.round(startNode.position.x), y: Math.round(startNode.position.y) }
        : { x: 0, y: 0 },
      viewport: viewport || null,
    },
  };
}
